import { Card } from "@/components/ui/card";
import { GuestCatalogCard } from "@/components/guest-catalog/GuestCatalogCard";
import { GuestCatalogListRow } from "@/components/guest-catalog/GuestCatalogListRow";
import type { GuestCatalogViewMode } from "@/components/guest-catalog/guestCatalogViewMode";
import type { GuestOpacResourceSummary } from "@/lib/api/guest-opac";

interface GuestCatalogItemViewProps {
  items: GuestOpacResourceSummary[];
  viewMode: GuestCatalogViewMode;
  tenantSlug?: string;
}

export function GuestCatalogItemView({ items, viewMode, tenantSlug }: GuestCatalogItemViewProps) {
  if (items.length === 0) return null;

  if (viewMode === "grid") {
    return (
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {items.map((item) => (
          <GuestCatalogCard key={item.publicId} item={item} tenantSlug={tenantSlug} />
        ))}
      </div>
    );
  }

  return (
    <Card className="overflow-hidden border border-gray-200">
      <div className="divide-y divide-gray-100">
        {items.map((item) => (
          <GuestCatalogListRow key={item.publicId} item={item} tenantSlug={tenantSlug} />
        ))}
      </div>
    </Card>
  );
}
